export default __webpack_public_path__ + "static/media/buckets.a7ef2014.svg";